document.addEventListener('DOMContentLoaded', function (){
    const selector = '.product__block-description';
    const targetUrl = '/pages/custom-orders';

    const container = document.querySelector(selector);

    if (container) {
        container.innerHTML = container.innerHTML.replace(
            /CUSTOM SIZE/g,
            `<a href="${targetUrl}">CUSTOM SIZE</a>`
        );
    }
});